<div class="cancelled-orders">
	<app-table
		[statesColumns]="statesColumns()"
		[settings]="{
			size: 'md',
			spreadContent: 'space-between',
			rowBorder: true,
			emptyTextPath: 'orders.empty',
		}"
		[items]="ordersResponse()?.orders ?? []"
		[isLoading]="isLoadingOrders()"
	>
		<app-table-column
			[settings]="{
				titlePath: 'orders.ticker',
				column: columnsCanceledOrdersEnum.tickerCompany,
				minWidthPx: 90,
				maxWidthPx: 150,
			}"
		>
			<ng-template let-item="item">
				<div class="ticker-column">
					@if (item.order_class === orderClassEnum.OCO) {
						<div class="ticker-oco">
							<img
								class="icon nested-double-arrow"
								src="/images/icons/nested-double-arrow.svg"
								alt="nested-double-arrow"
							/>
							<div class="ticker-info">
								<ng-container
									*ngTemplateOutlet="
										tickerDefault;
										context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
									"
								/>
								@if (item.children_order?.length) {
									<ng-container
										*ngTemplateOutlet="
											tickerDefault;
											context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
										"
									/>
								}
							</div>
						</div>
					} @else if (item.order_class === orderClassEnum.OTO) {
						<div class="ticker-oto">
							<ng-container
								*ngTemplateOutlet="
									tickerDefault;
									context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
								"
							/>
							@if (item.children_order?.length) {
								<div class="nested-icon">
									<img
										class="icon nested-arrow"
										src="/images/icons/nested-arrow.svg"
										alt="nested-arrow"
									/>
									<ng-container *ngTemplateOutlet="tickerDefault; context: { symbol: item.symbol }" />
								</div>
							}
						</div>
					} @else if (item.order_class === orderClassEnum.BRACKET) {
						<div class="ticker-bracket">
							<ng-container
								*ngTemplateOutlet="
									tickerDefault;
									context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
								"
							/>
							@if (item.children_order?.length) {
								<div class="nested-icon">
									<img
										class="icon nested-arrow"
										src="/images/icons/nested-arrow.svg"
										alt="nested-arrow"
									/>
									<ng-container *ngTemplateOutlet="tickerDefault; context: { symbol: item.symbol }" />
								</div>
								<div class="nested-icon">
									<img
										class="icon nested-arrow"
										src="/images/icons/nested-arrow.svg"
										alt="nested-arrow"
									/>
									<ng-container *ngTemplateOutlet="tickerDefault; context: { symbol: item.symbol }" />
								</div>
							}
						</div>
					} @else {
						<ng-container
							*ngTemplateOutlet="
								tickerDefault;
								context: { symbol: item.symbol, assetName: item.asset_name || item.symbol }
							"
						/>
					}
				</div>

				<ng-template
					#tickerDefault
					let-symbol="symbol"
					let-assetName="assetName"
				>
					<div class="ticker-default">
						<span
							class="symbol"
							(click)="setLiveTicker(symbol)"
							>{{ symbol }}</span
						>
						@if (assetName) {
							<span class="exchange">{{ assetName || symbol }}</span>
						}
					</div>
				</ng-template>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.operation',
				column: columnsCanceledOrdersEnum.operation,
				minWidthPx: 70,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<span
						class="text"
						highlight
						[isPositive]="item.side === orderSideEnum.BUY"
						[isNegative]="item.side === orderSideEnum.SELL"
					>
						{{ 'orders.side.' + item.side | translate }}
					</span>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								<span
									class="text"
									highlight
									[isPositive]="child.side === orderSideEnum.BUY"
									[isNegative]="child.side === orderSideEnum.SELL"
								>
									{{ 'orders.side.' + child.side | translate }}
								</span>
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.quantity',
				column: columnsCanceledOrdersEnum.quantity,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						class="text"
						>{{ item.qty | quantity }}</span
					>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								<span
									secret
									[isSecret]="isSecret()"
									[secretCount]="4"
									class="text"
									>{{ child.qty | quantity }}</span
								>
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.price',
				column: columnsCanceledOrdersEnum.price,
				minWidthPx: 100,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<div
						class="prices"
						[class.big]="item.type === orderTypeEnum.STOP_LIMIT"
					>
						@if (item.type === orderTypeEnum.LIMIT) {
							<span
								secret
								[isSecret]="isSecret()"
								[secretCount]="4"
								class="text"
								>{{ item.limit_price | price }}</span
							>
						}
						@if (item.type === orderTypeEnum.STOP) {
							<span
								secret
								[isSecret]="isSecret()"
								[secretCount]="4"
								class="text"
								>{{ item.stop_price | price }}</span
							>
						}
						@if (item.type === orderTypeEnum.STOP_LIMIT) {
							<span class="text">{{ item.limit_price | price }}</span>
							<span
								secret
								[isSecret]="isSecret()"
								[secretCount]="4"
								class="text sm"
								>{{ item.stop_price | price }}</span
							>
						}
						@if (item.type === orderTypeEnum.MARKET) {
							<span
								secret
								[isSecret]="isSecret()"
								[secretCount]="4"
								class="text"
								>-</span
							>
						}
						@if (item.type === orderTypeEnum.TRAILING_STOP) {
							<span
								secret
								[isSecret]="isSecret()"
								[secretCount]="4"
								class="text"
								>{{ item.stop_price | price }} ({{
									item.trail_percent ? (item.trail_percent | percent) : (item.trail_price | price)
								}})</span
							>
						}
					</div>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								@if (child.type === orderTypeEnum.LIMIT) {
									<span
										secret
										[isSecret]="isSecret()"
										[secretCount]="4"
										class="text"
										>{{ child.limit_price | price }}</span
									>
								}
								@if (child.type === orderTypeEnum.STOP) {
									<span
										secret
										[isSecret]="isSecret()"
										[secretCount]="4"
										class="text"
										>{{ child.stop_price | price }}</span
									>
								}
								@if (child.type === orderTypeEnum.STOP_LIMIT) {
									<div class="side-translation">
										<span
											secret
											[isSecret]="isSecret()"
											[secretCount]="4"
											class="text"
											>{{ child.limit_price | price }}</span
										>
										<span
											secret
											[isSecret]="isSecret()"
											[secretCount]="4"
											class="attribute"
											>{{ child.stop_price | price }}</span
										>
									</div>
								}
								@if (child.type === orderTypeEnum.TRAILING_STOP) {
									<span
										secret
										[isSecret]="isSecret()"
										[secretCount]="4"
										class="text"
										>{{ child.stop_price | price }} ({{
											child.trail_percent
												? (child.trail_percent | percent)
												: (child.trail_price | price)
										}})</span
									>
								}
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.orderType',
				column: columnsCanceledOrdersEnum.orderType,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<span class="text">{{ item | titleOrderType }}</span>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								<span class="text">{{ child | titleOrderType }}</span>
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.executed',
				column: columnsCanceledOrdersEnum.executed,
				minWidthPx: 70,
				maxWidthPx: 80,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						class="text"
						>{{ item.filled_qty }}</span
					>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								<span
									secret
									[isSecret]="isSecret()"
									[secretCount]="4"
									class="text child-order"
									>{{ child.filled_qty }}</span
								>
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'orders.statusTitle',
				column: columnsCanceledOrdersEnum.orderStatus,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="cell-column">
					<tui-badge
						class="badge"
						tuiBadge
						size="m"
						appearance="negative"
					>
						{{ 'orders.status.' + item.status | translate }}
					</tui-badge>
					@if (item.children_order?.length) {
						<div class="side-translation">
							@for (child of item.children_order; track child.id) {
								<tui-badge
									class="badge"
									tuiBadge
									size="m"
									appearance="negative"
								>
									{{ 'orders.status.' + child.status | translate }}
								</tui-badge>
							}
						</div>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-actions>
			<ng-template let-item="item">
				<app-canceled-orders-actions [order]="item" />
			</ng-template>
		</app-table-actions>

		<app-table-footer>
			<ng-template>
				<div class="footer">
					<div class="total">
						<span class="title">{{ 'orders.total' | translate }}:</span>
						<span
							class="value"
							[tuiSkeleton]="isLoadingOrders()"
							>{{ (ordersResponse()?.orders ?? []).length | quantity }}</span
						>
					</div>

					<app-pagination
						[isLoading]="isLoadingOrders()"
						[total]="ordersResponse()?.count ?? 0"
						[pageIndex]="ordersParams()?.page ?? 1"
						(pageChange)="onPageChange($event)"
					/>
				</div>
			</ng-template>
		</app-table-footer>
	</app-table>
</div>
